import React from 'react';

const Label = ({contenu, isRequired = false}) => {
    return (
        <div className={"label"}>
            <span className={"contenu"}>{contenu}</span>
            {isRequired && <span className={"required"}> *</span>}
        </div>
    );
};

export default Label;
